import React, { Component } from "react";
import { Row, Typography } from "antd";
import "./AuthSideBar.scss";

const { Text } = Typography;

export default class AuthSideBar extends Component {
  render() {
    return (
      <Row className="auth-sidebar-container">
        <Row className="image" />
        <a href="/">
          <Row type="flex" className="logo" />
        </a>
        <Row className="copyright">
          <Text className="text">Copyright @ 2025 WRKFLOZ, Inc</Text>
          <Row className="link">
            <a href="https://www.wrkfloz.net/_files/ugd/d8f992_b7593d655b9d43dca0a39fe1007ca474.pdf">Terms and conditions</a>
            <a href="https://www.wrkfloz.net/_files/ugd/d8f992_b7593d655b9d43dca0a39fe1007ca474.pdf">Privacy Policy</a>
          </Row>
        </Row>
      </Row>
    );
  }
}
